import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/LoadingError/Loading";
import Message from "../../components/LoadingError/Error";
import PostCard from "../../components/Posts/PostCard";
import Pagination from "../../core/components/common/Pagination";
import EmptyList from "../../components/EmptyList";

import { useApi } from "../../core/contexts/ApiProvider";
import { useUser } from "../../core/contexts/UserProvider";
import NotificationList from "../../components/NotificationList";

const NotificationPage = () => {
  const api = useApi();
  const navigate = useNavigate();
  const query = useLocation().search;

  const { user } = useUser();
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);
  const [userNotifications, setUserNotifications] = useState([]);
  const [globalNotifications, setGlobalNotifications] = useState([]);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  const clearNotifications = () => {
    setGlobalNotifications([]);
  };

  useEffect(() => {
    (async () => {
      const response = await api.get(`/api/notifications/0`);
      if (response.success) {
        setUserNotifications(response.userNotifications);
        setGlobalNotifications(response.globalNotifications);
      }
    })();
  }, []);

  return (
    <div className="relative bg-white px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex space-x-10">
          <div className="flex-[3]">
            <div className="py-4 px-4 flex items-center justify-between sticky top-0 z-10 bg-white">
              <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 py-6">
                Notifications
              </h1>
              <div className="flex items-center space-x-2">
                <button
                  className="text-sm text-red-500 hover:text-red-700"
                  onClick={clearNotifications}
                >
                  Marquer tout comme lu
                </button>
              </div>
            </div>

            {loading ? (
              <div className="mb-5">
                <Loading />
              </div>
            ) : (
              <>
                {globalNotifications.length > 0 ? (
                  globalNotifications.map((notification, index) => (
                    <Link key={index} to={notification.targetActionUrl}>
                      <li className="px-4 py-4 hover:bg-gray-50 transition cursor-pointer">
                        <div className="flex items-start">
                          <div className="flex-shrink-0">
                            <div
                              className={`h-10 w-10 rounded-full flex items-center justify-center ${
                                notification.type === "success"
                                  ? "bg-green-500"
                                  : notification.type === "error"
                                  ? "bg-red-500"
                                  : "bg-blue-500"
                              } text-white`}
                            >
                              {notification.icon || "🔔"}
                            </div>
                          </div>
                          <div className="ml-4">
                            <p className="text-sm font-medium text-gray-800">
                              {notification.title}
                            </p>
                            <p className="text-sm text-gray-600">
                              {notification.message}
                            </p>
                            <p className="text-xs text-gray-400 mt-1">
                              {notification.time}
                            </p>
                          </div>
                        </div>
                      </li>
                    </Link>
                  ))
                ) : (
                  <EmptyList
                    title={"Vous n'avez aucune notification"}
                    description={
                      "Revenez plus tard pour voir vos notifications ici."
                    }
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationPage;
